import type { ParsedUrlQuery } from 'querystring';
import type { PLPLayoutSlot as PLPlayoutSchema } from '@amplience/content-types/typings/s-plp-layout';
import type { Category, Product } from '@storefront/lib-global/codegen/types';
import type { HandlebarTemplateProps } from '@storefront/lib-global/globalComponents/handlebarTemplate';
import { ProductList } from './productList/ProductList';

export type PLPLayoutProps = {
  plpLayout: PLPlayoutSchema;
  category: Category;
  products?: Product[] & { queryID: string };
  handlebarComponents: HandlebarTemplateProps[] | null;
  query?: ParsedUrlQuery;
  isMobile?: boolean;
};

export function PLPLayout({ plpLayout, category, products, handlebarComponents, query, isMobile }: PLPLayoutProps) {
  return (
    <ProductList
      plpLayout={plpLayout}
      products={products}
      category={category}
      handlebarComponents={handlebarComponents}
      query={query}
      isMobile={isMobile}
    />
  );
}
